import { render, staticRenderFns } from "./ResetPasswordContent.vue?vue&type=template&id=57daea81"
import script from "./ResetPasswordContent.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports